var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFB300;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#90CAF9;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FF7043;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#9CCC65;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#37474F;}\n\t.st7{fill:#37474F;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#37474F;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business_Team"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50.5,
    y1: 15.5,
    x2: 55.5,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 57.5,
    y1: 15.5,
    x2: 58.5,
    y2: 15.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.5,
    y1: 15.5,
    x2: 8.5,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.5,
    y1: 15.5,
    x2: 5.5,
    y2: 15.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 8.5,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,3.9l0.6-0.5c-1.5-1.8-3.7-2.9-6.1-2.9c-4.4,0-8,3.6-8,8h0.8C29.4,8.5,34,6.9,37.5,3.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,16.5c-1.1,0-2.1-0.2-3-0.6l0,1.6l3,4.5l3-4.5l0-1.6C34.1,16.3,33.1,16.5,32,16.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 39,
    y1: 27.5,
    x2: 39,
    y2: 34.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25,
    y1: 27.5,
    x2: 25,
    y2: 34.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "34.5,34 32,36.5 29.5,34 31,22 33,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29,17.5 28.5,22 35.5,22 35,17.5 32,22  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,28.9v-4.2c0-2-1.2-3.8-3-4.6l-6-2.7L32,22l-3-4.5l-6,2.7c-1.8,0.8-3,2.6-3,4.6v4.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.5,
    cy: 35.5,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,30.9l0.6-0.5c-1.5-1.8-3.7-2.9-6.1-2.9c-4.4,0-8,3.6-8,8h0.8C9.9,35.5,14.5,33.9,18,30.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,43.5c-1.1,0-2.1-0.2-3-0.6l0,1.6l3,4.5l3-4.5l0-1.6C14.6,43.3,13.6,43.5,12.5,43.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19.5,
    y1: 54.5,
    x2: 19.5,
    y2: 61.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.5,
    y1: 54.5,
    x2: 5.5,
    y2: 61.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "15,61 12.5,63.5 10,61 11.5,49 13.5,49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.5,44.5 9,49 16,49 15.5,44.5 12.5,49  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.5,61.5v-9.8c0-2-1.2-3.8-3-4.6l-6-2.7l-3,4.5l-3-4.5l-6,2.7c-1.8,0.8-3,2.6-3,4.6v9.8"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 51.5,
    cy: 35.5,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57,30.9l0.6-0.5c-1.5-1.8-3.7-2.9-6.1-2.9c-4.4,0-8,3.6-8,8h0.8C48.9,35.5,53.5,33.9,57,30.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.5,43.5c-1.1,0-2.1-0.2-3-0.6l0,1.6l3,4.5l3-4.5l0-1.6C53.6,43.3,52.6,43.5,51.5,43.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 58.5,
    y1: 54.5,
    x2: 58.5,
    y2: 61.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 44.5,
    y1: 54.5,
    x2: 44.5,
    y2: 61.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "54,61 51.5,63.5 49,61 50.5,49 52.5,49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "48.5,44.5 48,49 55,49 54.5,44.5 51.5,49  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.5,61.5v-9.8c0-2-1.2-3.8-3-4.6l-6-2.7l-3,4.5l-3-4.5l-6,2.7c-1.8,0.8-3,2.6-3,4.6v9.8"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 32,
    y1: 39,
    x2: 32,
    y2: 45
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "26.4,48.6 32,45 37.6,48.6  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkers);
export default __webpack_public_path__ + "static/media/workers.52446356b77d32654ecab4bbc7cf97c2.svg";
export { ForwardRef as ReactComponent };